import * as React from "react";

import { BrowserRouter, Navigate, Routes, Route } from "react-router-dom";
import Signup from "./pages/Signup/Signup";
import RoleRoutes from "./rbac/RoleRoutes";
import Login from "./pages/Login/Login";
import ForgotPassword from "./pages/ForgotPassword/ForgotPassword";
import ChangePassword from "./pages/ChangePassword/ChangePassword";
import LandingPage from "./pages/LandingPage/LandingPage";
import OldLandingPage from "./pages/LandingPage/archive/LandingPage.old";
import TermsOfService from "./pages/TermsOfService/TermsOfService";
import PrivacyPolicy from "./pages/PrivacyPolicy/PrivacyPolicy";
import ContactUs from "./pages/ContactUs/ContactUs";
import {
  APIsCatalogue,
  CompanyProfileGuide,
  FundingTrackerGuide,
  GuidesCatalogue,
  ShakeChilliesHome,
} from "./pages/ShakeChillies/ShakeChillies";

function App() {
  //TODO: 10. Deployment + Domain name
  //TODO: 7. User plan structure.
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/old-landing-page" element={<OldLandingPage />} />
        <Route path="/terms-of-service" element={<TermsOfService />}></Route>
        <Route path="/privacy-policy" element={<PrivacyPolicy />}></Route>
        <Route path="/contact-us" element={<ContactUs />}></Route>
        <Route path="/shakechillies" element={<ShakeChilliesHome />} />
        <Route path="/shakechillies/guides" element={<GuidesCatalogue />} />
        <Route path="/shakechillies/apis" element={<APIsCatalogue />} />
        <Route
          path="/shakechillies/guides/company-profile-enrichment"
          element={<CompanyProfileGuide />}
        />
        <Route
          path="/shakechillies/guides/startup-funding-tracker"
          element={<FundingTrackerGuide />}
        />
        <Route
          path="/shakechillies/*"
          element={<Navigate to="/shakechillies" replace />}
        />
        <Route path="/signup" element={<Signup />}></Route>
        <Route path="/login" element={<Login />}></Route>
        <Route path="/forgot-password" element={<ForgotPassword />}></Route>
        <Route path="/change-password" element={<ChangePassword />}></Route>
        <Route path="/*" element={<RoleRoutes />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
